import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-progress-bar-paqueteria',
  templateUrl: './progress-bar-paqueteria.component.html',
  styleUrls: ['./progress-bar-paqueteria.component.scss']
})
export class ProgressBarPaqueteriaComponent implements OnInit {

  @Input() data: any;
  @Input() carrier: any;

  @Output() customAction = new EventEmitter<void>();
  
    chartData:any;
  
    colorsMapping:any = {
      'paquetexpress': { color:'#223e88'},
      'dhl': { color:'#ffcc01'},
      'afimex': { color:'#9108b2'},
      'estafeta': { color:'#c00d0d'},
      'estafeta mexico': { color: '#c00d0d' },
      'est': { color: '#c00d0d' },
      'fedex': { color:'#ff6200'},
      '99minutos': { color:'#85c440'},
    };
  
    constructor(
    ) { }
  
    ngOnInit(): void {
      this.chartData = this.barChartProgress(this.data);
    }
  
    barChartProgress = (data:any) => {
      return (
        {
          chart: {
            height: 55,
            type: "bar",
            stacked: true,
            sparkline: {
              enabled: true,
            },
            events: {
              dataPointSelection: (event: any, chartContext: any, config: any) => {
                this.customAction.emit();
              }
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: "30%",
              colors: {
                  backgroundBarColors: ["#bbb"],
                  backgroundBarOpacity: 0.2,
              },
            },
          },
          colors: [this.getColorForCarrier(this.carrier)],
          stroke: {
            width: 0,
          },
          fill: {
            colors: [this.getColorForCarrier(this.carrier)],
          },
          series: [
            {
              data: [data],
            },
          ],
          tooltip: {
            enabled: false,
          },
          xaxis: {
            categories: ["Packed"],
          },
          yaxis: {
            max: 100,
            min: 0,
          },
          responsive: [
            {
              breakpoint: 767,
              options: {
                title: {
                  style: {
                    fontSize: "16px",
                  },
                },
              },
            },
          ]
        }
      )
    }
  
    getColorForCarrier(carrier: string): string {
      if(carrier != null){
        carrier = carrier.toLowerCase();
        for (let key in this.colorsMapping) {
          if (carrier.includes(key)) {
            return this.colorsMapping[key].color;
          }
        }
      }
      
      return '#000000';
    }

    


}
